import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  Stethoscope,
  UserRound,
  CalendarCheck2,
} from "lucide-react";
import { scrollToTop } from "../utils/scrollToTop";
import { useSessionStorageState } from "../hooks/useSessionStorageState";
import { useLanguage } from "../i18n/LanguageContext";

interface NavItem {
  id: string;
  label: string;
  icon: React.ComponentType<any>;
  link: string;
}

export default function BottomNavApp() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [, setSearchResults] = useSessionStorageState("searchResults", []);

  const navigation: NavItem[] = [
    {
      id: "home",
      label: t("trangchu"),
      icon: Home,
      link: "/",
    },
    {
      id: "clinic",
      label: t("phongkham"),
      icon: Stethoscope,
      link: "/phong-kham",
    },
    {
      id: "doctor",
      label: t("bacsi"),
      icon: UserRound,
      link: "/bac-si",
    },
    {
      id: "records",
      label: t("lichhen"),
      icon: CalendarCheck2,
      link: "/phieu-kham",
    },
  ];

  const navItems = navigation.map((item) => ({
    ...item,
    isActive:
      item.link !== "#" &&
      (pathname === item.link || pathname.startsWith(item.link + "/")),
  }));

  const onItemClick = (item: NavItem) => {
    if (item.link === "/phieu-kham") {
      setSearchResults([]);
    }

    navigate(item.link);
    scrollToTop();
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50"
      role="navigation"
      aria-label="Bottom navigation"
    >
      <div
        className="
          mx-auto w-full max-w-md
          border-t border-[#e7efe9]
          bg-white/95 backdrop-blur-md
          shadow-[0_-6px_24px_rgba(15,23,42,0.08)]
        "
      >
        <div className="grid grid-cols-4 items-center px-2 py-2 h-[64px]">
          {navItems.map((item) => {
            const Icon = item.icon;

            return (
              <button
                key={item.id}
                type="button"
                onClick={() => onItemClick(item)}
                className="
                  relative flex min-w-0 flex-col items-center justify-center
                  rounded-2xl px-1 py-1
                  transition-all duration-200
                "
              >
                {item.isActive && (
                  <span
                    aria-hidden="true"
                    className="absolute inset-x-1 inset-y-0 rounded-2xl bg-[#eef7f0]"
                  />
                )}

                {item.id == "doctor" ? (
                  <img src="/icons/doctor-nav.svg" alt=""  className="w-6 h-6 relative z-10"/>
                ) : item.id == "records" ? (
                  <img src="/icons/calendar-nav.svg" alt=""  className="w-6 h-6 relative z-10"/>
                ) : (
                  <Icon
                    size={24}
                    strokeWidth={2.1}
                    className={`relative z-10 transition-all duration-200 ${item.isActive ? "text-[#215c46]" : "text-[#2d6b55]"
                      }`}
                  />
                )}

                <span
                  className={`relative z-10 mt-1 line-clamp-1 text-[11px] font-medium transition-colors duration-200 ${item.isActive ? "text-[#215c46]" : "text-[#2d6b55]"
                    }`}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}